(ns frontend.components.inputs.footprint)

(defmulti editor :editor/type)

(defmethod editor :default
  [params]
  (str "No 'editor' for '" (:editor/type params) "'"))


(defmulti viewer :editor/type)

(defmethod viewer :default
  [params]
  (str "No 'viewer' for '" (:editor/type params) "'"))


(defmulti display-string :editor/type)

(defmethod display-string :default
  [params]
  (str "No 'display-string' for '" (:editor/type params) "'"))
